export enum GameMessageType {
    DEFAULT = 'default',
    SUCCESS = 'success',
    DANGER = 'danger',
    INFO = 'info',
    WON_MESSAGE = 'won_message',
    LEVEL_UP = 'level_up',
}
